import { Injectable } from '@angular/core';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { DataSelectors } from '@app/store/data/data.selectors';
import { Store } from '@ngxs/store';
import { OfficeService } from './office.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private store: Store,
    private officeService: OfficeService,
  ) { }

  get officecd() {
    return this.store.selectSnapshot(AuthSelectors.objectcd);
  }

  get userList() {
    return this.store.selectSnapshot(DataSelectors.userList(this.officecd)) || null;
  }

  get groupList() {
    return this.store.selectSnapshot(DataSelectors.userGroupList(this.officeService.officecd)) || [];
  }

  daiInfo(daicd: string = '') {
    if (this.userList && daicd !== '')
      return this.userList?.find((x) => x.daicd === daicd) || null;
    else return null;
  }
}
